import { Pipe, PipeTransform } from '@angular/core';
import { NotificationService } from '@sharedServices/notification.service';

@Pipe({
  name: 'removeDuplicateFiles'
})

export class RemoveDuplicateFilesPipe implements PipeTransform {

  constructor(
    private notificationService: NotificationService
  ) {}

  /**
   * transform
   * @param fileListArray - Array of existing file(s) (must be in same format as received from 'encode' pipes)
   * @param newFileList - FileList of newly selected file(s)
   * @return File[] - Array of file(s) excluding duplicate(s)
   */
  transform(fileListArray: any, newFileList: FileList): File[] {
    const newFileListArray = Array.from(newFileList)

    fileListArray.forEach(file => {
      newFileListArray.forEach((newFile: File, index: number) => {
        const originalFile = file.originalFile || file.originalImage

        if(originalFile.name === newFile.name && originalFile.type === newFile.type && originalFile.size === newFile.size &&
          originalFile.lastModified === newFile.lastModified) {
          this.notificationService.showWarning(`Skipping "${newFile.name}" as this file is already encoded`, 'Duplicate File')
          newFileListArray.splice(index, 1)
        }
      })
    })
    return newFileListArray
  }
}
